import LawFirmAutoSuggest from './LawFirmAutoSuggest';
export default LawFirmAutoSuggest;